import { styled } from '@mui/material/styles';

export const ChangeNotificationStyledContainer = styled('div')`
  position: relative;
  text-align: center;

  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .settings-wrapper {
    margin: 0 auto;
    background-color: #eaf9f2;
    display: flex;
  }

  .notification-title {
    font-size: 30px;
    color: #000000;
    font-weight: 400;
    text-align: center;
    margin-top: 20px;
    line-height: 41px;
  }

  .close-notification-button {
    max-width: none;
    text-align: center;
    height: 45px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 5px 70px;
    border-radius: 8px;
	margin-top: 30px;

    color: ${({ theme }) => theme.palette.secondary.main};
  }
`;
